"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _createNamedExportFrom(obj, localName, importedName) { Object.defineProperty(exports, localName, {enumerable: true, configurable: true, get: () => obj[importedName]}); }var _reactredux = require('react-redux');




var _usePlaySoundEffect = require('./usePlaySoundEffect'); _createNamedExportFrom(_usePlaySoundEffect, 'usePlaySoundEffect', 'default');



 const useAppSelector = _reactredux.useSelector.withTypes(); exports.useAppSelector = useAppSelector
 const useAppDispatch = _reactredux.useDispatch.withTypes(); exports.useAppDispatch = useAppDispatch
